/**
 * Mirrors the admin portal's module, so a screen that exists in both places is
 * built from the same values. Nothing here authors a literal colour, size or
 * weight, so a value that changes in `@hopdrive/ui` changes everywhere.
 */
import { allTokens, type ElevationLevel } from '@hopdrive/ui/tokens';

export { allTokens };
export type { ElevationLevel };

/**
 * An elevation token as a CSS box-shadow, for places that render something
 * other than a themed `Card`, which has a shadow already.
 */
export const getElevation = (level: ElevationLevel): string =>
  level.layers
    .map(layer => `${layer.offsetX}px ${layer.offsetY}px ${layer.blur}px ${layer.spread}px rgba(0,0,0,${layer.opacity})`)
    .join(', ');

/** Mono, for an id or a key: something the reader compares character by character. */
export const MONO_FONT = `"${allTokens.typography.fontFamily.mono}", monospace`;

export const TABLE_HEADER_SX = {
  padding: '10px 16px',
  textTransform: 'uppercase' as const,
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: '0.04em',
  color: allTokens.text.light.secondary,
  border: 0,
  whiteSpace: 'nowrap' as const,
};
